import { NavLink } from "react-router-dom";

function SectionServices1() {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-our-services-outer sx-bg-light">
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center" style={{direction: 'rtl'}}>
                        <div className="sx-head-s-title">خدمات ویراپ</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">ویراپ با توسعه نرم‌افزارهای سازمانی، تحلیل داده‌ها و راهکارهای هوش مصنوعی و بلاکچین، ابزارهای نوآورانه‌ای برای رشد و بهینه‌سازی کسب‌وکارها ارائه می‌دهد.</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="sx-our-services-bx">
                            <div className="row">
                                {/* Block one */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-service-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-service-bx-icon scale-in-center">
                                                <span className="sx-text-primary"><i className="flaticon-security" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">راهکارهای هوش مصنوعی</h4>
                                                <p>ارائه سیستم‌ها و ابزارهای مبتنی بر هوش مصنوعی برای بهبود فرآیندها، پیش‌بینی دقیق و تصمیم‌گیری هوشمند.</p>
                                                <div className="sx-center-btn">
                                                    <NavLink to="/" className="site-button-circle">
                                                        <i className="fa fa-long-arrow-left" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Two */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-service-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-service-bx-icon scale-in-center">
                                                <span className="sx-text-primary"><i className="flaticon-coding" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">توسعه نرم‌افزار و تحلیل داده‌ها</h4>
                                                <p>طراحی و پیاده‌سازی نرم‌افزارهای سفارشی و ارائه راهکارهای جامع برای تحلیل و مدیریت داده‌های سازمانی.</p>
                                                <div className="sx-center-btn">
                                                    <NavLink to="/" className="site-button-circle active">
                                                        <i className="fa fa-long-arrow-left" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Block Three */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                    <div className="sx-service-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-service-bx-icon scale-in-center">
                                                <span className="sx-text-primary"><i className="flaticon-smart-contracts" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">خدمات غیر متمرکز بلاکچینی</h4>
                                                <p>طراحی و توسعه برنامه‌های غیرمتمرکز (DApps) و راهکارهای نوآورانه بر پایه فناوری بلاکچین و قراردادهای هوشمند.</p>
                                                <div className="sx-center-btn">
                                                    <NavLink to="/" className="site-button-circle">
                                                        <i className="fa fa-long-arrow-left" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionServices1;